module.exports = __webpack_public_path__ + "img/DE00666.d3f49f9b.png";